import axios from 'axios'
import {
  EventTarget as RealEventTarget,
  defineEventAttribute,
} from 'event-target-shim'

export const states = {
  ERROR: 'error',
  PREPARE: 'prepare',
  START: 'start',
  PROGRESS: 'progress',
  END: 'end',
}

export default class S3Uploader extends RealEventTarget {
  constructor(podcastId) {
    super()

    this.podcastId = podcastId
  }

  generateUniqueFileName(file) {
    const parts = file.name.split('.')
    const extension = parts.pop()
    const name = parts.join('.')
    return `${name}__${Date.now()}.${extension}`
  }

  async getUploadUrl(fileName, token, tenant) {
    try {
      const { data } = await axios.get('/.netlify/functions/upload-url', {
        params: {
          podcast: this.podcastId,
          file: fileName,
          tenant,
          token,
        },
      })

      return {
        readUrl: data.readUrl,
        writeUrl: data.writeUrl,
        error: null,
      }
    } catch (err) {
      console.dir(err)
      return {
        readUrl: null,
        writeUrl: null,
        error: err,
      }
    }
  }

  async upload(file, token, tenant) {
    this.dispatch(states.PREPARE)

    const { readUrl, writeUrl, error } = await this.getUploadUrl(
      this.generateUniqueFileName(file),
      token,
      tenant,
    )

    if (!readUrl) {
      this.dispatch(states.ERROR, {
        error,
      })
      return null
    }

    this.dispatch(states.START)

    try {
      await axios.put(writeUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
        onUploadProgress: progressEvent =>
          this.dispatch(states.PROGRESS, {
            progress: Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            ),
          }),
      })
    } catch (err) {
      this.dispatch(states.ERROR, {
        error: err,
      })
      return null
    }

    this.dispatch(states.END)

    return readUrl
  }

  dispatch(state, details = {}) {
    this.dispatchEvent(
      new CustomEvent('state', {
        detail: {
          state,
          ...details,
        },
      }),
    )
  }
}

defineEventAttribute(S3Uploader.prototype, 'state')
